import { Marshal } from "../../../fstn/marshal";
import { Transition } from "../../../fstn/transition";
import Actions from "./Actions";
import Goto from "./Goto";
import Transitions from "./Transitions";
import React from "react";
import {ProjectDetails} from "../../../redux/types/firebase";
import NodeHeader from "./NodeHeader";
import {IStateMeta} from "../../../fstn/state";
import {getStyles} from "../../../utility/Style";
import {connect} from "react-redux";
import {selectConstants} from "../../../redux/selectors/firebase";
import {Constants, Tags} from "../StateTags";
import {Box} from "@mui/material";

interface Props
{
    constants: Constants
    id: string
    data: {
        actions: Marshal[]
        child?: string
        goto?: { label: string, destination: string }[]
        initial: string
        label: string
        meta: IStateMeta
        onTransitionDelete: (source: string, target: string | undefined, trigger: string | undefined) => void
        transitions: Transition[]
    }
    onClickGoto: (id: string) => void
    onContextMenu: (event: React.MouseEvent<HTMLElement>) => void
    projectDetails: ProjectDetails
    tags: Tags
}

function ActionLayout({constants, id, data, onClickGoto, onContextMenu, projectDetails, tags}: Props)
{
    const bodyStyle = getStyles(id, tags, data.meta.blockNames || [], constants, "body");

    return <>
        <NodeHeader data={data} onContextMenu={onContextMenu} id={id} projectDetails={projectDetails}/>
        <Box className={bodyStyle}><Actions actions={data.actions} /></Box>
        <Goto id={id} goto={data.goto} onClickGoto={onClickGoto} />
        <Transitions transitions={data.transitions} id={id} onJump={onClickGoto} />
    </>
}
const mapStateToProps = (store: never) => ({
    constants: selectConstants(store),
});

export default connect(mapStateToProps, {
})(ActionLayout);